var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link"},[(_vm.fontIcon)?_c('FontIcon',{attrs:{"name":_vm.fontIcon}}):_vm._e(),_c('a',{staticClass:"link-text text5",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }